module.exports = __webpack_public_path__ + "components/rewards/no-ads/static/logo-e8259f888b574b10bd51ddcca57b9d82.webp";